/**
 * 🌾 useRoamZoneGate — single source of truth for whether the Castle
 *    Courtyard roaming zone is unlocked.
 *
 * Canon: The player wakes in the Tomb of Awakening (Scene I) with a
 * dropped 500-Chit pouch. Emerging into the Central Square puts them
 * at the Stone Fountain in the Dragonious Castle Courtyard — where
 * Grandma Cari is standing. So the gate is:
 *
 *   ✅ authenticated  AND
 *   ✅ user has ≥ 500 Chits (post-Tomb baseline)
 *
 * Returns `{ unlocked, reason }` so every entry point can either
 * enable the link or show the exact lore-flavored gate hint.
 */
import { useAuth } from "@/contexts/AuthContext";

export function useRoamZoneGate() {
  const { user } = useAuth();
  if (!user) {
    return { unlocked: false, reason: "Sign in to walk the courtyard." };
  }
  const chits = Number(user.chits ?? 0);
  if (chits < 500) {
    return {
      unlocked: false,
      reason: "Wake in the Tomb and pocket the dropped 500 Chits first.",
    };
  }
  return { unlocked: true, reason: "" };
}
